import React from 'react'
import Button, { BaseButtonProps } from './Button'
import { Link, LinkProps } from 'react-router-dom'
import { Type } from './types'

export interface LinkButtonProps extends BaseButtonProps, LinkProps {
  children?: React.ReactChild
  onClick?: () => void
  type?: Type
}

export const LinkButton = ({ children, ...props }: LinkButtonProps) => (
  <Button {...props} as={Link}>
    {children}
  </Button>
)
